export const COLORS = {
  Dark: "#3B3B3B",
  DarkGray: "#505050",
  DarkMidGray: "#65676B",
  White: "#ffffff",
  Black: "#050505",
  // Primary: "#0044EF",
  Primary: "#4DAD5B",
  BgSelect: '#F3FAEF',
  Bg: "#F2F3F5",
  Gray: "#898989",
  LightGray: "#bcc5d3",
  Secondary: "#D0E0FF",
  Error: "#E73845",
  Success: "#9BC383",
  YellowPending: "#FEBB02",
  GreenInProgress: "#3BA223",
  GreenComplete: "#066738",
  GreenBrown:'#0CA150',
  Purple: '#1D3557',
  GreenStrong: '#08A250',
  //   GrayBg: "#f8f8f8",
};
